import React, { useState, useEffect } from 'react';
import { makeGetRequest } from '../services/httpHelper';
import ErrorHandler from '../services/ErrorHandler';

const FaithStatements = () => {
  const [statements, setStatements] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const church = JSON.parse(localStorage.getItem('church'));

  const getStatements = async () => {
    setIsLoading(true);
    const res = await makeGetRequest(`faith-statements/${church.id}`);

    if (res && res.errorType) {
      setIsLoading(false);
      const errorMessage = ErrorHandler(res);
      setError(errorMessage);
    } else {
      const results = await res.data;
      setStatements(results);
      setIsLoading(false);
      setError(null);
    }
  };

  useEffect(() => {
    getStatements();
  }, []);

  return (
    <div className="container my-5">
      <h3 className="mb-4 text-start text-dark">Our Doctrines</h3>

      {isLoading && <p>Loading...</p>}
      {error && <p className="text-danger">{error}</p>}

      {statements && statements.length === 0 ? (
        <p>No doctrines right now, check back later.</p>
      ) : (
        <div className="row">
          {statements.map((st, index) => (
            <div className="col-12 col-md-6 mb-4" key={st.id}>
              <div className="card shadow-sm h-100" style={{ borderRadius: '12px' }}>
                <div className="card-body">
                  <p className="card-text">
                    <strong>{index + 1}.</strong> {st.statement}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FaithStatements;
